/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}
// 对象数组去重
export function removDuplicate(oldArr, uniqueValue) {
  let hash = {};
  let newArr = oldArr.reduce(function (prev, item, _this) {
    hash[item[uniqueValue]] ?
      '' :
      (hash[item[uniqueValue]] = true && prev.push(item));
    return prev;
  }, []);
  return newArr;
}

// 数组去重
export function unique(arr) {
  let newArr = []
  let len = arr.length
  for (let i = 0; i < len; i++) {
    if (newArr.indexOf(arr[i]) == -1) {
      newArr.push(arr[i])
    }
  }
  return newArr
}


export const formValidation = {
  www: (rule, value, callback) => {
    var strRegex = /^(http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\*\+,;=.]+$/
    if (value == null || value == "") {
      callback();
    } else {
      var arr = value.match(strRegex);
      if (arr) {
        var re2 = /^(.+\.)(com|edu|gov|int|mil|net|org|biz|info|name|museum|html|coop|aero|[a-z][a-z])$/;
        if (!re2.test(arr[0])) {
          callback(new Error('官网链接格式不正确'));
        } else {
          callback();
        }
      } else {
        callback(new Error('官网链接格式不正确'));
      }
    }
  },

  phone: (rule, value, callback) => {
   //// const phoneReg = /^1[3|4|5|6|7|8][0-9]{9}$/

    var checktel = /^0?(10|(2|3[1,5,7]|4[1,5,7]|5[1,3,5,7]|7[1,3,5,7,9]|8[1,3,7,9])[0-9]|91[0-7,9]|(43|59|85)[1-9]|39[1-8]|54[3,6]|(701|580|349|335)|54[3,6]|69[1-2]|44[0,8]|48[2,3]|46[4,7,8,9]|52[0,3,7]|42[1,7,9]|56[1-6]|63[1-5]|66[0-3,8]|72[2,4,8]|74[3-6]|76[0,2,3,5,6,8,9]|82[5-7]|88[1,3,6-8]|90[1-3,6,8,9])\d{7,8}$/;  
    var checkphone = /^1[3|4|5|6|7|8][0-9]{9}$/;

    if (!value) {
      return callback(new Error('电话号码不能为空'))
    }
    if (!Number.isInteger(+value)) {
      callback(new Error('请输入数字值'))
    } else {
      //if (phoneReg.test(value)) {
      if ( checktel.test(value) || checkphone.test(value)) {
        callback()
      } else {
        callback(new Error('电话号码格式不正确'))
      }
    }
  },

  number: (rule, value, callback) => {
    if (typeof value === 'number') {

      //console.log(value)
      if (value == '' && value != 0) {
        callback(new Error('不能为空'))
      } else if (value < 0) {
        callback(new Error('不能为负数'))
      } else if(value == 0){
        callback(new Error('请填写大于0的数字'))
      }else{
        callback()
      }
    } else {
      callback(new Error('请输入数值'))
    }

  },
  phoneAndLandline: (rule, value, callback) => {

    let regPone = null;
    let mobile = /^1(3|4|5|6|7|8|9)\d{9}$/;
    let tel = /^(0[0-9]{2,3}\-)([2-9][0-9]{4,7})+(\-[0-9]{1,4})?$/; //座机
    if (!Number.isInteger(+value)) {

      callback(new Error('请输入数字值'))
    } else {

      if (value.charAt(0) == 0) { // charAt查找第一个字符方法，用来判断输入的是座机还是手机号
        regPone = tel;
      } else {
        regPone = mobile;
      }

      if (!regPone.test(value)) {

        callback(
          new Error("请填写联系人电话(座机格式'区号-座机号码')")
        );
      } else {

        callback();
      }
    }
  },
  isNullObject:(value)=>{
    if(typeof value === 'object'){

      if(JSON.stringify(value) == "{}"){
        return true
      } else{
        return false
      }
    }
  },
  isNullString:(rule, value, callback)=>{
    //console.log(value)
      if (value == undefined || "" ) {
        callback(new Error('不能为空'))
      } else {
        callback()
      }
    
  },


  stringLength:(rule, value, callback) => {
     //console.log(rule.fieldLable+':'+value)
    if (value === ''||value === null||value === undefined) {
      ///callback(new Error('为空验证'));
      callback()
    } else{
      var len = 0;  
      for (var i=0; i<value.length; i++) {   
          var c = value.charCodeAt(i);   
          //单字节加1   
          if ((c >= 0x0001 && c <= 0x007e) || (0xff60<=c && c<=0xff9f)) {   
              len++;   
          } else {   
              len+=3;   
          }   
      };   
    //  //console.log(len)
      if ( len > rule.max) {
          //重点重点，下面就是填写提示的文字
          ////callback(new Error(rule.fieldLable+'长度为'+rule.max+'个字符，一个中文字等于3个字符。'));
          callback(new Error(rule.fieldLable+'长度超最大限制。'));
      } else {
          callback();
      }
      
    }
      
  }

}
